import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css'
import { PatientCareCenterNoteChargesGroupRow } from './GroupRow';

class PatientCareCenterNoteChargesGroupGait extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div>
                    <div className={styles.row}>
                        <span className={styles.col1} >
                            <b>Gait (97116)</b>
                        </span>
                        <span className={styles.col2}>
                            <div className={styles.int_field}>
                            </div>
                        </span>
                    </div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const act = this.props.activities[key];
                            return (
                                <PatientCareCenterNoteChargesGroupRow
                                    key={act.id}
                                    id={act.id}
                                    table='MLGAIT'
                                    prefix='XLGA'
                                    noteId={this.props.noteId}
                                    activity={act.activity}
                                    selected={act.selected}
                                />

                            )
                        })
                    }

                </div>
            );
        } else {
            return (<span />);
        }
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));

    let activities = Object.keys(state.entities.notes.MLGAIT)
        .filter(key => {
            return (state.entities.notes.MLGAIT[key].XLGAXLNO === xlno &&
                state.entities.notes.MLGAIT[key].XLGAPERFORMED === true)
        })
        .sort((a, b) => state.entities.notes.MLGAIT[a].XLGANO - state.entities.notes.MLGAIT[b].XLGANO)
        .map(key => {
            let act = state.entities.notes.MLGAIT[key].XLGAACTIVITY ? state.entities.notes.MLGAIT[key].XLGAACTIVITY + ' - ' : '<activity not defined> - ';
            act += state.entities.notes.MLGAIT[key].XLGAGANO ?
                state.entities.masterData.MLMASTERGAITASSDEV[state.entities.notes.MLGAIT[key].XLGAGANO].GANAME + ' - ' : '<device not defined> - ';
            act += state.entities.notes.MLGAIT[key].XLGAGLNO ?
                state.entities.masterData.MLMASTERGAITLEVASS[state.entities.notes.MLGAIT[key].XLGAGLNO].GLNAME + ' - ' : '<LOA not defined> - ';
            act += state.entities.notes.MLGAIT[key].XLGAGSNO ?
                state.entities.masterData.MLMASTERGAITSURFACE[state.entities.notes.MLGAIT[key].XLGAGSNO].GSNAME : '<surface not defined>';
            return {
                activity: act,
                id: state.entities.notes.MLGAIT[key].XLGANO,
                selected: state.entities.notes.MLGAIT[key].XLGAISGROUP
            };
        });

    return {
        noteId,
        noteType,
        xlno,
        activities
    };
}

const connectedPatientCareCenterNoteChargesGroupGait = connect(mapStateToProps)(PatientCareCenterNoteChargesGroupGait);
export { connectedPatientCareCenterNoteChargesGroupGait as PatientCareCenterNoteChargesGroupGait };

